import { Dimensions, PixelRatio } from "react-native";
import { inIframe } from "./helper";

let screenWidth = inIframe() ? 1024 : Dimensions.get("window").width,
  screenHeight = inIframe() ? 768 : Dimensions.get("window").height;

// Font/icon down-scaling for lower-resolution / small desktop windows. The
// size tiers throughout the app are keyed on width only, so a short window is
// treated as a full-size desktop and the largest fonts / icons overflow.
//
// IMPORTANT: Dimensions.get("screen") returns the physical monitor size
// (window.screen.*) which does NOT change when the browser window is resized.
// We must use the actual viewport (Dimensions.get("window") === innerWidth/
// innerHeight) to know how much space the content really has. The monitor
// width is only used to detect "is this a desktop/laptop" so that genuine
// mobile devices (which already get smaller width-based sizes) are left alone.
const monitorWidth = inIframe() ? 1024 : Dimensions.get("screen").width;
const viewportHeight = inIframe() ? 768 : Dimensions.get("window").height;
const isCompactScreen = monitorWidth > 700 && viewportHeight < 900;
const fontScale = !isCompactScreen
  ? 1
  : viewportHeight < 700
  ? 0.72
  : viewportHeight < 800
  ? 0.8
  : 0.88;
const scaleSize = (size) =>
  typeof size === "number" ? Math.round(size * fontScale) : size;

const widthPercentageToDP = (e) => {
    const t = "number" == typeof e ? e : parseFloat(e);
    return PixelRatio.roundToNearestPixel((screenWidth * t) / 100);
  },
  heightPercentageToDP = (e) => {
    const t = "number" == typeof e ? e : parseFloat(e);
    return PixelRatio.roundToNearestPixel((screenHeight * t) / 100);
  },
  listenOrientationChange = (e) => {
    Dimensions.addEventListener("change", (t) => {
      // screenWidth = t.window.width;
      // screenHeight = t.window.height;
      // e.setState({
      //   orientation: screenWidth < screenHeight ? "portrait" : "landscape",
      // });
    });
  },
  removeOrientationListener = () => {
    Dimensions.removeEventListener("change", () => {});
  };

export {
  widthPercentageToDP,
  heightPercentageToDP,
  listenOrientationChange,
  removeOrientationListener,
  screenWidth,
  screenHeight,
  scaleSize,
  fontScale,
  isCompactScreen,
};
